"use strict";
/**
 * A function which receives the initial immutable value from a depo state instance,
 * and creates a shallow proxy for it, with a getter trap for each store value
 * sub-object.
 *
 * This proxy is then provided to the consumer's `mapStateToProps()` function as its first
 * argument, and allows Depo React to collect the names of all observed stores, as data is read
 * from them.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var createProxyFromInitialValue = function (value) {
    var lastAcessedStoreNames = [];
    var proxy = Object.keys(value).reduce(function (proxyUnderConstruction, storeName) {
        return Object.defineProperty(proxyUnderConstruction, storeName, {
            get: function () {
                lastAcessedStoreNames.push(storeName);
                return value[storeName];
            }
        });
    }, {});
    /**
     * Returns the list of all store names from which data has been read from
     * since the last call of the function. The list is emptied after every
     * call to ensure that the store names are completely isolated for each
     * consumer provided `mapStateToProps()` function.
     */
    var getStoreNames = function () {
        var storeNames = lastAcessedStoreNames.slice();
        lastAcessedStoreNames.length = 0;
        return storeNames;
    };
    return [proxy, getStoreNames];
};
exports.default = createProxyFromInitialValue;
//# sourceMappingURL=createProxyFromInitialValue.js.map